var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-tabs",
    {
      staticClass: "custom-tab",
      attrs: { type: "border-card" },
      model: {
        value: _vm.activeName,
        callback: function ($$v) {
          _vm.activeName = $$v
        },
        expression: "activeName",
      },
    },
    [
      _c(
        "el-tab-pane",
        { attrs: { label: "订单列表", name: "a" } },
        [
          _vm.activeName === "a"
            ? _c("Order", { attrs: { activeName: _vm.activeName } })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-tab-pane",
        { attrs: { label: "报价列表", name: "b" } },
        [
          _vm.activeName === "b"
            ? _c("quotation", { attrs: { activeName: _vm.activeName } })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }